import { deserializeFilter, Filter } from "./filter";
import {
  useDeleteSavedFilter,
  useListSavedFilters,
  useUpdateSavedFilter,
} from "../data/saved-filter";
import { useMemo } from "react";

type FilterAndFunctions = {
  id: string;
  filter: Filter;
  name: string;
  isDefault: boolean;
  setName: (name: string) => void;
  setDefault: (yes: boolean) => void;
  remove: () => void;
};
export const useFilters = (): FilterAndFunctions[] => {
  const filters = useListSavedFilters();
  const update = useUpdateSavedFilter();
  const remove = useDeleteSavedFilter();

  return useMemo(
    () =>
      (filters?.data?.filters ?? [])
        .map(({ id, nickname, url, is_default: isDefault }) => {
          const filter = deserializeFilter(url);
          return filter
            ? {
                id,
                filter,
                name: nickname,
                isDefault,
                setDefault: (yes: boolean) => {
                  update.mutate({ id, nickname, isDefault: yes });
                  if (yes) {
                    const prevDefault = filters?.data?.filters.find(
                      (f) => f.is_default
                    );
                    if (prevDefault && prevDefault.id !== id) {
                      update.mutate({
                        id: prevDefault.id,
                        nickname: prevDefault.nickname,
                        isDefault: false,
                      });
                    }
                  }
                },
                setName: (name: string) =>
                  update.mutate({ id, nickname: name, isDefault }),
                remove: () => remove.mutate({ id }),
              }
            : undefined;
        })
        .filter((x) => !!x),
    [filters]
  );
};

export const useDefaultFilter = (): Filter | undefined => {
  const filters = useListSavedFilters();
  return useMemo(() => {
    if (filters?.data) {
      const defaultFilter = filters.data.filters.find((x) => x.is_default);
      if (defaultFilter) {
        const parsedFilter = deserializeFilter(defaultFilter.url);
        if (parsedFilter) {
          return parsedFilter;
        }
      }
    }
  }, [filters]);
};
